import { app } from '../../services/feathers'

// eslint-disable-next-line import/prefer-default-export
export async function getOneTeam(id) {
  return app.service('teams').get(id)
}
